import Async from 'react-select/async';
import AsyncCreatable from 'react-select/async-creatable';
import { components } from 'react-select';
import React from 'react';
import { useColorModeValue, Flex, Box, Text } from '@chakra-ui/react';
const PassBuilderValueContainer = ({ children, ...containerProps }) => {
  const { selectProps } = containerProps;
  const childArray = React.Children.toArray(children);
  const input = childArray[childArray.length - 1];
  return (
    <components.ValueContainer {...containerProps}>
      {!selectProps.inputValue && (
        <Text
          fontSize="14px"
          fontFamily="Inter, sans-serif"
          color="#4C4C4C"
          position="absolute"
          pointerEvents="none"
        >
          {selectProps.placeholder}
        </Text>
      )}
      {input}
    </components.ValueContainer>
  );
};

const CustomSearchableSelect = (props) => {
  const { options, value, onChange, loadOptions, ...rest } = props;

  const modePlaceholderColor = useColorModeValue(
    'rgba(59, 72, 81, 0.6)',
    props.liveEventData ? '#ddd' : '#7F8488'
  );
  const modeMenuBg = useColorModeValue('#fff', '#2F343D');
  const modeMenuColor = useColorModeValue('#000000', '#fff');
  const modeMenuBgHover = useColorModeValue(
    'rgba(221, 221, 221, 0.5)',
    '#000000'
  );
  const modeBorderHover = useColorModeValue('#2F343D', '#fff');
  const modeInputBgPassStatus = useColorModeValue(
    'rgba(221, 221, 221, 0.5)',
    '#000000'
  );

  const styles = {
    control: (provided) => ({
      ...provided,
      padding: '2px 10px',
      marginTop: '10px',
      backgroundColor:
        props.variant === 'light' ? '#fff' : modeInputBgPassStatus,
      display: 'flex',
      borderRadius: '12px',
      border: '2px solid transparent',
      boxShadow: 'none',
      ':hover': {
        borderColor: modeBorderHover,
        transition: 'all .3s ease-in-out',
        cursor: 'pointer',
      },
    }),
    option: (provided) => ({
      ...provided,
      color: modeMenuColor,
      backgroundColor: modeMenuBg,
      ':hover': {
        backgroundColor: modeMenuBgHover,
        color: modeMenuColor,
      },
    }),
    menu: (provided) => ({
      ...provided,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '0px',
      zIndex: '5',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: modePlaceholderColor,
      fontSize: '14px',
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: modeMenuColor,
      ':hover': {
        color: modeMenuColor,
        cursor: 'pointer',
      },
      svg: {
        width: '1em',
        height: '1em',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      paddingRight: '0px',
      color: modeMenuColor,
      ':hover': {
        color: modeMenuColor,
        cursor: 'pointer',
      },
      svg: {
        width: '1em',
        height: '1em',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      color: 'white',
      backgroundColor: props.isDisabled ? '#B8BCBF' : '#FF4935',
      borderRadius: '10px',
      padding: '0px 5px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'white',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: 'white',
      ':hover': {
        color: 'white',
      },
    }),
  };

  const moreFiltersStyles = {
    control: (provided, state) => ({
      ...provided,
      marginTop: '10px',
      minHeight: '40px',
      padding: '0 12px',
      backgroundColor: state.menuIsOpen ? '#F8F8F8' : '#FFFFFF',
      borderRadius: state.menuIsOpen ? '5px 5px 0 0' : '5px',
      border: 'none',
      borderColor: 'transparent',
      boxShadow: 'none',
      cursor: 'pointer',
      ':hover': {
        border: 'none',
        borderColor: 'transparent',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
      fontSize: '13px',
      color: '#989898',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'white' : '#F8F8F8',
      color: state.isSelected ? '#505E69' : '#989898',
      fontSize: '13px',
      minHeight: '42px',
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: 'white',
        color: '#505E69',
      },
      ':active': {
        backgroundColor: 'white',
      },
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '0',
      borderRadius: '0 0 5px 5px',
      border: 'none',
      boxShadow: 'none',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '0',
      borderRadius: '0 0 5px 5px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#989898',
      fontSize: '13px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0',
      color: '#989898',
      transition: 'transform 0.2s',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
      ':hover': {
        color: '#989898',
        cursor: 'pointer',
      },
      svg: {
        width: '14px',
        height: '14px',
      },
    }),
    multiValue: () => ({
      display: 'none',
    }),
    multiValueLabel: () => ({
      display: 'none',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#505E69',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: 'transparent',
        color: '#505E69',
      },
      svg: {
        width: '10px',
        height: '10px',
      },
    }),
    clearIndicator: () => ({
      display: 'none',
    }),
  };

  const MoreFiltersValueContainer = ({ children, ...containerProps }) => {
    const selectedValues = containerProps.getValue();
    return (
      <components.ValueContainer {...containerProps}>
        {selectedValues.length > 0 ? (
          <>
            <Flex align="center" gap="2px">
              <Flex
                bg="rgba(80, 94, 105, 0.2)"
                border="1px solid #505E69"
                borderRadius="5px"
                px="8px"
                py="3px"
                align="center"
                gap="7px"
                minWidth={0}
              >
                <Text
                  fontSize="14px"
                  fontFamily="Inter, sans-serif"
                  color="#505E69"
                  wordBreak="break-word"
                >
                  {selectedValues[0].label}
                </Text>
                <Box
                  as="span"
                  cursor="pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    const remaining = selectedValues.slice(1);
                    containerProps.selectProps.onChange(remaining, {
                      action: 'remove-value',
                      removedValue: selectedValues[0],
                    });
                  }}
                >
                  <svg width="9" height="9" viewBox="0 0 7 7" fill="none">
                    <path
                      d="M1 1L6 6M6 1L1 6"
                      stroke="#505E69"
                      strokeWidth="1.2"
                      strokeLinecap="round"
                    />
                  </svg>
                </Box>
              </Flex>
              {selectedValues.length > 1 && (
                <Text
                  fontSize="13px"
                  color="#505E69"
                  fontFamily="Inter, sans-serif"
                  whiteSpace="nowrap"
                >
                  <Text as="span" position="relative" top="4px">
                    ,
                  </Text>{' '}
                  (+{selectedValues.length - 1})
                </Text>
              )}
            </Flex>
            {React.Children.toArray(children).slice(-1)}
          </>
        ) : (
          children
        )}
      </components.ValueContainer>
    );
  };

  const MoreFiltersMenuList = (menuListProps) => {
    const { children, selectProps } = menuListProps;
    const hasValue = selectProps.value && selectProps.value.length > 0;
    return (
      <components.MenuList {...menuListProps}>
        {children}
        {hasValue && (
          <Flex
            h="25px"
            align="center"
            justify="flex-end"
            px="8px"
            bg="#F8F8F8"
            borderBottomRadius="5px"
            cursor="pointer"
            onClick={() => {
              selectProps.onChange([], { action: 'clear' });
              selectProps.onMenuClose();
            }}
          >
            <Text fontSize="10px" color="red" fontFamily="Inter, sans-serif">
              Remove all
            </Text>
          </Flex>
        )}
      </components.MenuList>
    );
  };

  const MoreFiltersOption = (optionProps) => {
    const { isSelected, children, innerRef, innerProps, data } = optionProps;
    const count = data?.count;
    return (
      <Flex
        ref={innerRef}
        {...innerProps}
        align="center"
        gap="8px"
        px="8px"
        minH="52px"
        py="8px"
        bg={isSelected ? 'white' : '#F8F8F8'}
        color={isSelected ? '#505E69' : '#989898'}
        fontSize="13px"
        cursor="pointer"
        _hover={{ bg: 'white', color: '#505E69' }}
      >
        <Box
          w="12px"
          h="12px"
          flexShrink={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {isSelected && (
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path
                d="M10 3L4.5 8.5L2 6"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </Box>
        <Flex
          bg={
            isSelected ? 'rgba(80, 94, 105, 0.2)' : 'rgba(228, 228, 228, 0.5)'
          }
          border="1px solid"
          borderColor={isSelected ? '#505E69' : '#989898'}
          borderRadius="5px"
          px="8px"
          py="3px"
          align="center"
          gap="7px"
          minWidth={0}
        >
          <Text
            fontSize="13px"
            fontFamily="Inter, sans-serif"
            color={isSelected ? '#505E69' : '#989898'}
            wordBreak="break-word"
          >
            {children}
            {count != null && (
              <Text as="span" fontSize="12px">
                {' '}
                ({count} {count === 1 ? 'pass' : 'passes'})
              </Text>
            )}
          </Text>
        </Flex>
      </Flex>
    );
  };

  const passBuilderStyles = {
    control: (provided, state) => ({
      ...provided,
      marginTop: '10px',
      minHeight: '35px',
      padding: '0 12px',
      backgroundColor: '#EEEEEE',
      borderRadius: state.menuIsOpen ? '10px 10px 0 0' : '10px',
      border: 'none',
      boxShadow: 'none',
      cursor: 'pointer',
      ':hover': {
        border: 'none',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
      fontSize: '14px',
      color: '#4C4C4C',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'white' : '#F8F8F8',
      color: state.isSelected ? '#505E69' : '#989898',
      fontSize: '13px',
      minHeight: '40px',
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: 'white',
        color: '#505E69',
      },
      ':active': {
        backgroundColor: 'white',
      },
    }),
    menu: (provided) => ({
      ...provided,
      marginTop: '0',
      borderRadius: '0 0 10px 10px',
      border: 'none',
      boxShadow: 'none',
      zIndex: 5,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '0',
      borderRadius: '0 0 10px 10px',
      maxHeight: '200px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#4C4C4C',
      fontSize: '14px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: '0',
      color: '#4C4C4C',
      transition: 'transform 0.2s',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
      ':hover': {
        color: '#4C4C4C',
        cursor: 'pointer',
      },
      svg: {
        width: '14px',
        height: '14px',
      },
    }),
    multiValue: () => ({
      display: 'none',
    }),
    multiValueLabel: () => ({
      display: 'none',
    }),
    multiValueRemove: () => ({
      display: 'none',
    }),
    clearIndicator: () => ({
      display: 'none',
    }),
  };

  const getStyles = () => {
    if (props.passBuilder) return passBuilderStyles;
    if (props.moreFilters) return moreFiltersStyles;
    return styles;
  };

  const getComponents = () => {
    if (props.passBuilder) {
      return {
        Option: MoreFiltersOption,
        ValueContainer: PassBuilderValueContainer,
      };
    }
    if (props.moreFilters) {
      return {
        Option: MoreFiltersOption,
        MenuList: MoreFiltersMenuList,
        ValueContainer: MoreFiltersValueContainer,
      };
    }
    return undefined;
  };

  const SelectComponent = props.passBuilder ? AsyncCreatable : Async;

  return (
    <SelectComponent
      defaultOptions={options}
      value={value}
      onChange={onChange}
      loadOptions={loadOptions}
      styles={getStyles()}
      hideSelectedOptions={
        props.moreFilters || props.passBuilder ? false : undefined
      }
      closeMenuOnSelect={
        props.moreFilters || props.passBuilder ? false : undefined
      }
      components={getComponents()}
      formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
      {...rest}
    />
  );
};

export default CustomSearchableSelect;
